<p-dialog header="Session Expired" [(visible)]="visible" [modal]="true" [closable]="false">
    <div>
        <p>Would you like to continue your session?</p>
    </div>
    <p-footer>
        <button pButton label="Continue" (click)="onContinue()" icon="pi pi-check"></button>
        <button pButton label="Logout" (click)="onLogout()" icon="pi pi-times" class="p-button-danger"></button>
    </p-footer>
</p-dialog>